import { api } from ".";
import { LasServiceContractBase } from "../types/lasServiceContractBase";
import { LasServiceUpdate } from "../types/lasServiceUpdate";

export default class LasServiceApi {
  static async login(id: number, email: string) {
    const res = await api.post("/lasServiceContract/login", {
      id: id,
      email: email,
    });
    return res.data;
  }

  static async getContract(): Promise<LasServiceContractBase> {
    const res = await api.get("/lasServiceContract/getContract");
    return res.data;
  }

  static async getUpdatedLasService(id: number): Promise<LasServiceUpdate> {
    const res = await api.get(
      `/lasServiceContract/getUpdatedLasService?id=${id}`
    );
    return res.data;
  }

  static async updateLasService(
    price: string,

    serviceId: number
  ): Promise<LasServiceContractBase> {
    const res = await api.post("/lasServiceContract/updateLasService", {
      lasServiceUpdate: {
        price: price,
      },
      serviceId: serviceId,
    });
    return res.data;
  }

  static async updateContract(
    responsibleName: string,
    responsibleEmail: string,
    witnessName: string,
    witnessEmail: string,
    iva: string
  ): Promise<LasServiceContractBase> {
    const res = await api.post("/lasServiceContract/updateContract", {
      lasServiceContractUpdate: {
        responsibleName: responsibleName,
        responsibleEmail: responsibleEmail,
        witnessEmail: witnessEmail,
        witnessName: witnessName,
        iva: iva,
      },
    });
    return res.data;
  }

  static async partialUpdateContract(
    responsibleName: string,
    responsibleEmail: string,
    witnessName: string,
    witnessEmail: string,
    iva: string
  ): Promise<LasServiceContractBase> {
    const res = await api.post("/lasServiceContract/partialUpdateContract", {
      lasServiceContractUpdate: {
        responsibleName: responsibleName,
        responsibleEmail: responsibleEmail,
        witnessEmail: witnessEmail,
        witnessName: witnessName,
        iva: iva,
      },
    });
    return res.data;
  }

  static async setKeepConditions(keepConditions: boolean) {
    await api.post("/lasServiceContract/setKeepConditions", {
      keepConditions: keepConditions,
    });
  }

  static async setProblem(issueText: string) {
    await api.post("/lasServiceContract/problem", {
      issueText: issueText,
    });
  }
}
